<div fxLayout="column">
  <div>
    <h1 class="page-header left">General Motors Argentina</h1>
  </div>
  <div>
    <h3 class="page-header left">Sistema de Remitos</h3>
  </div>
  <div class="img-container">
    <img class="home-img" src="/assets/images/home.png" alt="">
  </div>
</div>
